import { render } from "./WanShe.vue?vue&type=template&id=68bc80e8&scoped=true"
import script from "./WanShe.vue?vue&type=script&lang=js"
export * from "./WanShe.vue?vue&type=script&lang=js"

import "./WanShe.vue?vue&type=style&index=0&id=68bc80e8&lang=less&scoped=true"
import "./WanShe.vue?vue&type=style&index=1&id=68bc80e8&scoped=true&lang=less"

import exportComponent from "F:\\aishezhen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc80e8"]])

export default __exports__